import React, { useState, useRef, useEffect } from "react";
import { Checkbox } from "sr/helpers";
import { Button } from "sr/helpers/ui-components/company/Button";
import { ModelWrapperWithButton } from "app/pages/company/component/ModelWrapperWithButton";
import TaskForm from "../forms/TaskForm";
import { AllChecklist } from "../../ChecklistTemplate/AllChecklist";
import ChecklistForm from "../forms/ChecklistForm";
import { Checklist } from "../Tables/Checklist";
import { Task } from "../Tables/Task";
import { FormattedMessage } from "react-intl";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getChecklist } from "sr/utils/api/company/customer/getChecklist";
import { AddChecklist } from "./component/AddChecklist";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { updateChecklist } from "sr/utils/api/company/customer/updateChecklist";
import { createTasklists } from "sr/utils/api/company/customer/createTasklists";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { Warning } from "sr/helpers/ui-components/company/Warning";
import { Pagination } from "app/pages/component/Pagination";

export const ChecklistTab = () => {
  const [companyId, setCompanyId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [isEditCheckList, setIsEditCheckList] = useState(false);
  const [checklistdetails, setchecklistDetails] = useState([]);
  const [addChecklistPopup, setAddChecklistPopup] = useState(false);
  const [TaskPopup, setTaskPopup] = useState(false);
  const [checklistId, setchecklistId] = useState("");
  const [taskadded, setTaskAdded] = useState(0);
  const [editChecklistPopup, setEditChecklistPopup] = useState(false);
  const [loader, setLoader] = useState("");
  const [copyChecklistid, setCopyChecklistId] = useState(-1);
  const [addMore, setAddMore] = useState(false);
  const [GlobalTemplate, setGlobalTemplate] = useState(false);
  const [copyTasks, setCopyTasks] = useState([]);
  const [userTasks, setUserTasks] = useState<any>();
  const params = useParams();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPage, settotalPage] = useState<number>(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const userDetails = getUserDetails();
    setCompanyId(userDetails?.user_id);
  }, []);

  useEffect(() => {
    const { id, checklistId } = params;
    setCustomerId(id);
    setchecklistId(checklistId);
  }, [params]);

  const fetchChecklist = async () => {
    try {
      setLoader("fetch");
      const queryParams = new URLSearchParams();
      if (customerId) queryParams.append("customer_id", customerId);
      queryParams.append("status!", "delete");
      queryParams.append("page", page?.toString());
      queryParams.append("limit", limit?.toString());
      const result = await getChecklist(queryParams);
      if (result.success === true) {
        setLoader("");
        setchecklistDetails(result?.data);
        settotalPage(Math.ceil(result?.pagination?.total / limit));
      } else {
        setLoader("");
      }
    } catch (e) {
      setLoader("");
    }
  };

  useEffect(() => {
    if (customerId) {
      fetchChecklist();
    }
  }, [customerId, page]);

  const resetModalState = () => {
    setGlobalTemplate(false);
    setCopyTasks([]);
    setAddMore(false);
  };

  const onCheckModel = (data) => {
    setTaskPopup(false);
    setAddChecklistPopup(false);
    setTaskPopup(false);
    setEditChecklistPopup(false);
    setIsEditCheckList(false);
    resetModalState();
    navigate(`${location.pathname.match(/^\/[^\/]*/)[0]}/${customerId}`);
  };

  interface TabRef {
    submitForm: () => void;
  }

  const childRef = useRef<TabRef>(null);

  const HandleFormSubmit = () => {
    if (childRef.current && childRef.current.submitForm) {
      childRef.current.submitForm();
    }
  };

  const dataAddedHandle = (data) => {
    if (data === "Checklist") {
      fetchChecklist();
    }
    if (data === "Task") {
      setTaskAdded(taskadded + 1);
      setAddMore(false);
    }
  };

  const HandleAddChecklist = () => {
    setTaskPopup(false);
    setAddChecklistPopup(false);
    resetModalState();
    navigate(`${location.pathname.match(/^\/[^\/]*/)[0]}/${customerId}`);
    fetchChecklist();
  };

  const HandleChecklistTask = (data) => {
    resetModalState();
    navigate(`${location.pathname}/${data}`);
    setTaskPopup(true);
  };

  const HandleEditChecklist = (data) => {
    navigate(`${location.pathname}/${data}`);
    setAddChecklistPopup(true);
    setIsEditCheckList(true);
  };

  const HandleEditChecklistSave = () => {
    if (childRef.current && childRef.current.submitForm) {
      childRef.current.submitForm();
    }
    navigate(`${location.pathname.match(/^\/[^\/]*/)[0]}/${customerId}`);
    setEditChecklistPopup(false);
  };

  const saveTaskHandle = () => {
    setAddMore(false);
  };

  const HandleDeleteChecklist = async (data) => {
    const formData = {
      id: data,
      status: "delete",
    };
    try {
      const res = await updateChecklist(
        formData,
        "API.SUCCESS.CUSTOMER.CHECKLIST.DELETE",
      );
      if (res?.success === true) {
        const filteredchecklist = checklistdetails?.filter(
          (item) => item.id !== data,
        );
        setchecklistDetails(filteredchecklist);
      }
    } catch (e) {}
  };

  const ChecklistHandle = async (tasks) => {
    setLoader("submit");
    const formData = [];
    for (let i = 0; i < tasks?.length; i++) {
      const data = {
        company_id: companyId,
        customer_id: customerId,
        checklist_id: checklistId,
        name: tasks[i]?.name,
        type: tasks[i]?.type,
        description: tasks[i]?.description,
        status: "active",
        position: i + 1,
      };
      formData.push(data);
    }

    setCopyTasks(tasks);
    try {
      const res = await createTasklists(formData);
      if (res.success === true) {
        const cPayload = {
          id: checklistId,
          status: "active",
        };
        const cres = await updateChecklist(cPayload);
        setTaskAdded(taskadded + 1);
        setLoader("");
      } else {
        setLoader("");
      }
    } catch (e) {
      setLoader("");
    }
  };

  const getTasks = (data) => {
    setUserTasks(data);
  };

  return (
    <>
      {loader === "submit" && <LoaderFullScreen />}
      <div className="py-4">
        <ModelWrapperWithButton
          showModal={addChecklistPopup}
          Save={HandleAddChecklist}
          onCheckModel={onCheckModel}
          savetext={"Save Checklist"}
          color={
            "bg-white text-[#0078ae] border border-neutral-200 hover:border-[#0078ae]"
          }
        >
          <AddChecklist isEditCheckList={isEditCheckList}></AddChecklist>
        </ModelWrapperWithButton>

        {/* View Task, Update Task, Add Task */}
        <ModelWrapperWithButton
          showModal={TaskPopup}
          Save={HandleAddChecklist}
          onCheckModel={onCheckModel}
          hideSaveButton={true}
        >
          {userTasks?.length === 0 && false && (
            <>
              <Checkbox
                id="Global"
                label={
                  <FormattedMessage
                    id="RECRUITER.CUSTOMER.CHECKLIST.GLOBAL.TITLE"
                    defaultMessage="Import from Global Checklist"
                  />
                }
                onChange={() => setGlobalTemplate(!GlobalTemplate)}
                value={GlobalTemplate}
              ></Checkbox>
              {/* ✅ Only show AllChecklist when checkbox is checked AND no tasks copied yet */}
              {GlobalTemplate && copyTasks.length === 0 ? (
                <AllChecklist ChecklistHandle={ChecklistHandle} />
              ) : null}
            </>
          )}
          <Task taskadded={taskadded} getTasks={getTasks} readOnly={true}></Task>
          {addMore && false && (
            <TaskForm dataAddedHandle={dataAddedHandle} ref={childRef} />
          )}
          {addMore && false && (
            <Button
              onClick={HandleFormSubmit}
              text={
                <FormattedMessage
                  id="RECRUITER.CUSTOMER.CHECKLIST.SAVE.TASK.BUTTON"
                  defaultMessage="Save Task"
                />
              }
            ></Button>
          )}
          {!addMore && false && (
            <Button
              onClick={() => setAddMore(true)}
              text={
                <FormattedMessage
                  id="RECRUITER.CUSTOMER.CHECKLIST.TASK.BUTTON"
                  defaultMessage="Add More Task"
                />
              }
            ></Button>
          )}
        </ModelWrapperWithButton>

        <ModelWrapperWithButton
          showModal={editChecklistPopup}
          Save={HandleEditChecklistSave}
          onCheckModel={onCheckModel}
        >
          <ChecklistForm
            ref={childRef}
            dataAddedHandle={dataAddedHandle}
          ></ChecklistForm>
        </ModelWrapperWithButton>

        <Warning
          text={"Checklist will save as a draft until tasks are added"}
        ></Warning>
        <Button
          onClick={() => setAddChecklistPopup(true)}
          text={
            <FormattedMessage
              id="RECRUITER.CUSTOMER.ADDCHECKLIST.BUTTON"
              defaultMessage="Add Checklist"
            />
          }
        ></Button>

        <ContentWithSpinner loader={loader === "fetch"}>
          {Object.keys(checklistdetails).length > 0 ? (
            <>
              <Checklist
                HandleDeleteChecklist={HandleDeleteChecklist}
                Viewicon={true}
                HandleChecklistTask={HandleChecklistTask}
                HandleEditChecklist={HandleEditChecklist}
                data={checklistdetails}
              />
            </>
          ) : null}
          <Pagination page={page} totalPage={totalPage} setPage={setPage} />
        </ContentWithSpinner>
      </div>

      <Link to={"/manage-customer"}>
        <Button
          buttoncss="bg-white hover:border-[#0078ae] !text-[#0078ae] border-neutral-200"
          hoverbg=""
          hovertext=""
          bordersize="border"
          text={
            <FormattedMessage
              id="RECRUITER.CUSTOMER.SAVE.BUTTON"
              defaultMessage="Save"
            />
          }
        ></Button>
      </Link>
    </>
  );
};
